import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import drive from './shared/drive'
// import './client'
import bungie from './shared/bungie'
Vue.use(VueRouter)

const router = new VueRouter({
	routes, // short for `routes: routes`
	mode:"hash",
	base:"index.html"
});

drive.authError(function() {
	router.push({ path: '/auth' });
});

const app = new Vue({
	router,
	el: '#app',
	// data: {
	// 	currentRoute: window.location.pathname
	// },
	// computed: {
	// 	ViewComponent() {
	// 		const matchingView = routes[this.currentRoute]
	// 		return matchingView ?
	// 			require('./pages/' + matchingView + '.vue') :
	// 			require('./pages/404.vue')
	// 	}
	// },
	// render(h) {
	// 	return h(this.ViewComponent)
	// }
})

// window.addEventListener('popstate', () => {
	// app.currentRoute = window.location.pathname
// })

var driveAuth = function () {
	// kickstart!
	gapi.auth.authorize(drive.auth, drive.refresh);
};

gapi.load('client', driveAuth);


// WEBPACK FOOTER //
// ./src/main.js